@if (showBadge()) {
  <span
    class="nav-label-container"
    [matBadgeOverlap]="false"
    [matBadge]="incompleteCount() > 0 ? incompleteCount() : undefined"
    matBadgeSize="small"
    matBadgePosition="below after">
    <ng-container [ngTemplateOutlet]="defaultTemplateRef" />
  </span>
} @else {
  <span>{{ navigationItem().label | translate }}</span>
}

<ng-template #defaultTemplateRef>
  <span>{{ navigationItem().label | translate }}</span>
</ng-template>
